import { useEffect, useRef, useState } from 'react';

import { Button, Typography, julo } from '@julo-ui/react';

import TncContent from './TncContent';
import ArrowLeft from '@new-components/shapes/ArrowLeft';

import useGlobalState from 'actions';
import { arrowCss, floatingChip } from 'pages/PrivacyPolicy/styles';
import useOnScreen from '@utils/useOnScreen';

import arrowDown from 'assets/icons/ic-arrow-down.svg';
import { tncDialog } from '../styles';

interface Props {
  onAcceptTnc: () => void;
  onRejectTnc: () => void;
}

const TncDialog = (props: Props) => {
  const { onAcceptTnc, onRejectTnc } = props;
  const [, globalActions] = useGlobalState();
  const [hasScroll, setHasScroll] = useState(false);
  const bottomRef = useRef<HTMLDivElement | null>(null);
  const didMountRef = useRef<boolean>();
  const isAtBottom = useOnScreen(bottomRef);

  const handleClickAutoScroll = () => {
    bottomRef?.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    if (!didMountRef.current) {
      setHasScroll(document.body.scrollHeight > window.innerHeight);
      didMountRef.current = true;
    }
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  const handleClose = () => {
    globalActions.openTnCDialog('open', false);
    globalActions.setState('sayaTelah', false);
    globalActions.setState('sayaTelahCheck', false);
    globalActions.setState('sayaTelah', false);
    onRejectTnc();
  };

  const handleAccept = () => {
    globalActions.openTnCDialog('open', false);
    globalActions.setState('sayaTelahCheck', true);
    onAcceptTnc();
  };

  return (
    <julo.div className={tncDialog}>
      <julo.div className='header'>
        <julo.div className='back-btn'>
          <ArrowLeft onClick={handleClose} />
        </julo.div>
        <Typography type='body' bold>
          Syarat Ketentuan
        </Typography>
      </julo.div>
      <TncContent />
      <div ref={bottomRef} />
      {hasScroll && !isAtBottom && (
        <div className={floatingChip} onClick={handleClickAutoScroll}>
          <img src={arrowDown} className={arrowCss(isAtBottom)} />
          Lihat ke {isAtBottom ? 'Atas' : 'Bawah'}
        </div>
      )}
      <julo.div className='actions'>
        <Button variant='secondary' onClick={handleClose}>
          Batal
        </Button>
        <Button onClick={handleAccept} disabled={!isAtBottom}>
          Lanjut
        </Button>
      </julo.div>
    </julo.div>
  );
};

export default TncDialog;
